// Contract date + time stay ISO YYYY-MM-DDTHH:mm while the UI stays day-first and 24-hour.
import { useEffect, useRef, useState } from 'react'
import { DateInput, TimeInput } from './SegmentedInput.jsx'

export function splitDateTime(value) {
  // a date with no time yet ("2026-09-22T") seeds the day boxes alone — the handover act offers the
  // contract's date that way (2026-09-22); the joined value stays '' until the time is typed
  const m = String(value || '').match(/^(\d{4}-\d{2}-\d{2})(?:T(\d{2}:\d{2}))?/)
  return m ? { date: m[1], time: m[2] || '' } : { date: '', time: '' }
}

export function joinDateTime(date, time) {
  return date && time ? `${date}T${time}` : ''
}

export function DateTimeInput({ value, onChange, className = '', disabled = false }) {
  const [parts, setParts] = useState(() => splitDateTime(value))
  const partsRef = useRef(parts)
  useEffect(() => {
    if (!value) return // keep the other completed segment while this one is being edited
    const next = splitDateTime(value)
    if (joinDateTime(partsRef.current.date, partsRef.current.time) !== joinDateTime(next.date, next.time)) {
      partsRef.current = next
      setParts(next)
    }
  }, [value])
  const change = (key, part) => {
    const next = { ...partsRef.current, [key]: part }
    partsRef.current = next
    setParts(next)
    onChange(joinDateTime(next.date, next.time))
  }
  return <div className="flex flex-wrap gap-2 max-w-full min-w-0" data-datetime-24h>
    <DateInput value={parts.date} onChange={date => change('date', date)} className={className} disabled={disabled} />
    <TimeInput value={parts.time} onChange={time => change('time', time)} className={className} disabled={disabled} />
  </div>
}
